import { Button, Modal, Select, Textarea } from "flowbite-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../Reducers/store";
import {
  fetchClientsWithLocationList,
  fetchUsers,
} from "../../../Actions/CommonFields";
import { Delivery } from "../../../Models/Delivery";
import Loader from "../../Common/Loader";
import { HiPlus } from "react-icons/hi";
import DeliveryApi from "../../../Api/DeliveryApi";
import { DeliveryItem } from "../../../Models/DeliveryItem";
import DeliveryItemListTable from "./DeliveryItemListTable";
import DeliveryItemModal from "./DeliveryItemModal";
import { DeliveryStatusEnum } from "../../../Models/DeliveryStatus";
import ClientLocationAssetModal from "../../Client/ClientLocationAssetModal";
import { ClientLocationAsset } from "../../../Models/ClientLocationAsset";
import ClientApi from "../../../Api/ClientApi";
import { Contact } from "../../../Models/Contact";
import ClientContactModal from "../../Client/Contact/ClientContactModal";
import SignaturePad from "react-signature-canvas";
import SignatureCanvas from "react-signature-canvas";
import SOPForm from "../SOPForm";
import dataURLtoBlob from "blueimp-canvas-to-blob";
import DeliveryItemNonInventoryModal from "./DeliveryItemNonInventoryModal";
import DeliveryItemNonInventoryListTable from "./DeliveryItemNonInventoryListTable";
import CommonApi from "../../../Api/CommonApi";
import { LatestDailyPrice } from "../../../Models/LatestDailyPrice";
import { LatestDailyPriceRequest } from "../../../Models/LatestDailyPriceRequest";
import { formatNumbersDisplayOnly } from "../../../Utils";
import { ClientMarkUp } from "../../../Models/ClientMarkUp";
import { UserLevelNames } from "../../../Models/UserLevel";
import { InventoryTypeEnum } from "../../../Models/InventoryType";
import { Inspection, InspectionTypeEnum } from "../../../Models/Inspection";
import { InspectionAsset } from "../../../Models/InspectionAsset";
import InspectionApi from "../../../Api/InspectionApi";
import { AssetTypeEnum } from "../../../Models/AssetType";
import { ClientLocation } from "../../../Models/ClientLocation";
import ViewReportModal from "../../Common/ViewReportModal";

export default function DeliveryModal({
  show,
  setShow,
  getDeliveries,
  getSchedulerData,
  selectedDelivery,
  setselectedDelivery,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  getDeliveries?: () => void;
  getSchedulerData?: () => void;
  selectedDelivery: Delivery | null;
  setselectedDelivery: React.Dispatch<React.SetStateAction<Delivery | null>>;
}) {
  const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);
  const { clientsWithLocation, users } = useAppSelector(
    (state) => state.commonFields
  );
  const sigPadref = useRef<SignatureCanvas>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<Delivery>({
    id: 0,
    clientLocationId: null,
    jobId: null,
    deliveredBy: null,
    dateDelivered: null,
    signature: null,
    startTime: null,
    endTime: null,
    inMileage: null,
    outMileage: null,
    acceptedBy: null,
    statusId: null,
    quickBooksId: null,
    notes: null,
    clientId: null,
    clientContactId: null,

    client: null,
    clientLocation: null,
    deliveryItems: [],
    status: null,
    deliveryAssets: [],
  });
  const [locationformData, setlocationformData] = useState<ClientLocation>({
    id: 0,
    clientId: null,
    typeId: null,
    address: null,
    city: null,
    stateId: null,
    zip: null,
    contactName: null,
    contactEmail: null,
    contactPhone: null,
    clientSiteId: null,
    ponumber: null,
    notes: null,
    quickbooksId: null,
    countryId: null,

    clientLocationAssets: [],
    country: null,
    state: null,
    type: null,
  });
  const [showdropTicketModal, setshowdropTicketModal] =
    useState<boolean>(false);
  const [pdfURL, setPDFURL] = useState<string>("");
  const [pdfBlob, setpdfBlob] = useState<Blob | null>(null);
  const [fileName, setfileName] = useState<string>("");

  const getReferences = async () => {
    if (!clientsWithLocation.length || !users.length) {
      await Promise.all([
        dispatch(fetchClientsWithLocationList()),
        dispatch(fetchUsers()),
      ]);
    }
    getUserLatestInspection();
  };

  useEffect(() => {
    getReferences();
  }, []);

  const handleSetInitialValues = () => {
    const values = selectedDelivery
      ? {
          ...selectedDelivery,
        }
      : {
          id: 0,
          clientLocationId: null,
          jobId: null,
          deliveredBy: null,
          dateDelivered: null,
          signature: null,
          startTime: null,
          endTime: null,
          inMileage: null,
          outMileage: null,
          acceptedBy: null,
          statusId: null,
          quickBooksId: null,
          notes: null,
          clientId: null,
          clientContactId: null,

          client: null,
          clientLocation: null,
          deliveryItems: [],
          status: null,
          deliveryAssets: [],
        };
    setFormData(values as Delivery);
    const locationvalues = selectedDelivery?.clientLocation
      ? {
          ...selectedDelivery?.clientLocation,
        }
      : {
          id: 0,
          clientId: null,
          typeId: null,
          address: null,
          city: null,
          stateId: null,
          zip: null,
          contactName: null,
          contactEmail: null,
          contactPhone: null,
          clientSiteId: null,
          ponumber: null,
          notes: null,
          quickbooksId: null,
          countryId: null,

          clientLocationAssets: [],
          country: null,
          state: null,
          type: null,
        };
    setlocationformData(locationvalues as ClientLocation);
  };

  useEffect(() => {
    if (clientsWithLocation) {
      handleSetInitialValues();
    }
  }, [selectedDelivery]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      clientLocationId: null,
      jobId: null,
      deliveredBy: null,
      dateDelivered: null,
      signature: null,
      startTime: null,
      endTime: null,
      inMileage: null,
      outMileage: null,
      acceptedBy: null,
      statusId: null,
      quickBooksId: null,
      notes: null,
      clientId: null,
      clientContactId: null,

      client: null,
      clientLocation: null,
      deliveryItems: [],
      status: null,
      deliveryAssets: [],
    };
    setFormData(values as Delivery);
    setButtonDisabled(false);
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "deliveredBy" ? (value ? Number(value) : null) : value,
    }));
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeTextAreaLocation = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setlocationformData((prevData) => ({ ...prevData, [name]: value }));
  };

  const [showDeliveryItemModal, setshowDeliveryItemModal] =
    useState<boolean>(false);
  const [
    showDeliveryItemNonInventoryModal,
    setshowDeliveryItemNonInventoryModal,
  ] = useState<boolean>(false);
  const [selectedDeliveryItem, setSelectedDeliveryItem] =
    useState<DeliveryItem | null>(null);
  const [deliveryItems, setdeliveryItems] = useState<DeliveryItem[]>([]);
  const [latestDailyPrice, setlatestDailyPrice] =
    useState<LatestDailyPrice | null>(null);
  const [clientMarkUp, setclientMarkUp] = useState<ClientMarkUp | null>(null);

  const editDeliveryItem = (item: DeliveryItem) => {
    setSelectedDeliveryItem(item);
    setshowDeliveryItemModal(true);
  };

  function deleteDeliveryItem(id: number) {
    const shouldRemove = window.confirm(
      "Are you sure you want to delete this?"
    );

    if (shouldRemove) {
      DeliveryApi.deleteDeliveryItem(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getDeliveryDeliveryItemsList();
          } else {
            toast.success("Error while deleting item");
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
        });
    }
  }

  const [clientContacts, setclientContacts] = useState<Contact[]>([]);
  const [showAddContactModal, setshowAddContactModal] =
    useState<boolean>(false);
  const getClientContacts = useCallback(() => {
    if (selectedDelivery) {
      try {
        setIsLoading(true);
        return ClientApi.getContactsForClient(selectedDelivery.clientId!)
          .then((res) => {
            setclientContacts(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error("Error");
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error("Error");
        setIsLoading(false);
      }
    }
  }, [selectedDelivery]);

  useEffect(() => {
    getClientContacts();
  }, [getClientContacts]);

  const getDeliveryDeliveryItemsList = useCallback(async (): Promise<void> => {
    if (!selectedDelivery?.id) return; // returns void
    setIsLoading(true);
    try {
      const res = await DeliveryApi.getDeliveryDeliveryItemsList(
        selectedDelivery.id
      );
      setdeliveryItems(res.data);

      // if you want SOPForm to see fresh items:
      setselectedDelivery((prev) =>
        prev ? { ...prev, deliveryItems: res.data } : prev
      );
    } catch (err) {
      toast.error("Error"); // ✅ do not return this
    } finally {
      setIsLoading(false);
    }
  }, [selectedDelivery?.id]);

  useEffect(() => {
    getDeliveryDeliveryItemsList();
  }, [getDeliveryDeliveryItemsList]);

  const getLatestDailyPrices = useCallback(() => {
    if (selectedDelivery) {
      try {
        setIsLoading(true);
        const request: LatestDailyPriceRequest = {
          date: new Date(),
          stateId: selectedDelivery.clientLocation?.stateId ?? 0,
        };

        return CommonApi.getLatestDailyPrices(request)
          .then((res) => {
            setlatestDailyPrice(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error("Error");
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error("Error");
        setIsLoading(false);
      }
    }
  }, [selectedDelivery]);

  useEffect(() => {
    getLatestDailyPrices();
  }, [getLatestDailyPrices]);

  const getClientInventoryMarkups = useCallback(() => {
    if (selectedDelivery && selectedDelivery.clientId) {
      try {
        setIsLoading(true);
        return ClientApi.getClientInventoryMarkups(selectedDelivery.clientId)
          .then((res) => {
            setclientMarkUp(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            console.error(err);
            toast.error("Error");
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error("Error");
        setIsLoading(false);
      }
    }
  }, [selectedDelivery]);

  useEffect(() => {
    getClientInventoryMarkups();
  }, [getClientInventoryMarkups]);

  const clientDEFPrice = () => {
    return (latestDailyPrice?.defPrice ?? 0) + (clientMarkUp?.defMarkUp ?? 0);
  };
  const clientClearDieselPrice = () => {
    return (
      (latestDailyPrice?.clearDieselPrice ?? 0) +
      (clientMarkUp?.clearDieselMarkUp ?? 0)
    );
  };
  const clientDyedDieselPrice = () => {
    return (
      (latestDailyPrice?.dyedDieselPrice ?? 0) +
      (clientMarkUp?.dyedDieselMarkUp ?? 0)
    );
  };

  const [showAddNewLocationAssetModal, setshowAddNewLocationAssetModal] =
    useState<boolean>(false);
  const [selectedClientLocationAsset, setselectedClientLocationAsset] =
    useState<ClientLocationAsset | null>(null);

  const editClientLocationAsset = (item: ClientLocationAsset | null) => {
    if (item) {
      setselectedClientLocationAsset(item);
      setshowAddNewLocationAssetModal(true);
    }
  };

  const viewDropTicket = async (d: Delivery) => {
    setIsLoading(true);
    return await DeliveryApi.getDropTicketReport(d.id)
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(pdfBlob);
        setpdfBlob(pdfBlob);
        setPDFURL(url);
        setfileName(
          d.client?.name ? d.client?.name + "_Drop Ticket" : "Drop Ticket"
        );
        setshowdropTicketModal(true);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error: " + err);
        setIsLoading(false);
      });
  };

  const saveLocationNotes = async () => {
    if (!locationformData.stateId) {
      locationformData.stateId = null;
    }
    return await ClientApi.addUpdateClientLocation(locationformData)
      .then((res) => {
        if (!res.data.success) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error: " + err);
      });
  };

  const deliveryApprove = async (statusId: number) => {
    setButtonDisabled(true);
    setIsLoading(true);
    formData.statusId = statusId;
    return await DeliveryApi.addUpdateDelivery(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success("Save Success");
          if (getSchedulerData) getSchedulerData();
          if (getDeliveries) getDeliveries();
          setButtonDisabled(false);
          setIsLoading(false);
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setButtonDisabled(false);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Error: " + err);
        setButtonDisabled(false);
        setIsLoading(false);
      });
  };

  const [showSubmitDropTicket, setshowSubmitDropTicket] =
    useState<boolean>(false);

  function onCloseModal() {
    handleResetFormValues();
    setselectedDelivery(null);
    setShow(false);
  }

  async function deliverySubmitComplete() {
    if (selectedDelivery) {
      await viewDropTicket(selectedDelivery);
    }
    saveLocationNotes();
    onCloseModal();
    if (getSchedulerData) getSchedulerData();
    if (getDeliveries) getDeliveries();
  }

  const clearSignature = () => {
    sigPadref.current?.clear();
  };

  const captureSignature = (): string | null => {
    if (sigPadref.current && !sigPadref.current.isEmpty()) {
      return sigPadref.current.toDataURL();
    }
    return null;
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Validate times
    if (timeErrors) {
      toast.error(timeErrors);
      return;
    }

    // Validate required fields
    if (!formData.clientContactId) {
      toast.error("Please select a contact");
      return;
    }

    setButtonDisabled(true);
    setIsLoading(true);

    try {
      // Capture signature if not already captured
      if (!formData.signature) {
        const signatureData = captureSignature();
        if (signatureData) {
          formData.signature = signatureData;
        }
      }

      // Set delivered by current user only if not already set by dropdown
      if (!formData.deliveredBy) {
        formData.deliveredBy = userModel?.id ?? null;
      }

      // Ensure startTime and endTime are sent with explicit timezone offset
      if (formData.startTime) {
        // Convert to local datetime with timezone offset
        const date = new Date(formData.startTime);
        const pad = (n: number) => String(n).padStart(2, "0");

        // Get timezone offset in minutes and convert to HH:MM format
        const offsetMinutes = date.getTimezoneOffset();
        const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
        const offsetMins = Math.abs(offsetMinutes) % 60;
        const offsetSign = offsetMinutes <= 0 ? "+" : "-";
        const timezoneOffset = `${offsetSign}${pad(offsetHours)}:${pad(
          offsetMins
        )}`;

        // Create ISO string with timezone offset
        formData.startTime = `${date.getFullYear()}-${pad(
          date.getMonth() + 1
        )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
          date.getMinutes()
        )}:00${timezoneOffset}`;
        console.log(
          "Sending startTime with timezone offset:",
          formData.startTime
        );
      }

      if (formData.endTime) {
        // Convert to local datetime with timezone offset
        const date = new Date(formData.endTime);
        const pad = (n: number) => String(n).padStart(2, "0");

        // Get timezone offset in minutes and convert to HH:MM format
        const offsetMinutes = date.getTimezoneOffset();
        const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
        const offsetMins = Math.abs(offsetMinutes) % 60;
        const offsetSign = offsetMinutes <= 0 ? "+" : "-";
        const timezoneOffset = `${offsetSign}${pad(offsetHours)}:${pad(
          offsetMins
        )}`;

        // Create ISO string with timezone offset
        formData.endTime = `${date.getFullYear()}-${pad(
          date.getMonth() + 1
        )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
          date.getMinutes()
        )}:00${timezoneOffset}`;
        console.log("Sending endTime with timezone offset:", formData.endTime);
      }

      const res = await DeliveryApi.addUpdateDelivery(formData);

      if (res && res.data.success) {
        toast.success("Save Success");

        // Save location notes
        await saveLocationNotes();

        if (getSchedulerData) getSchedulerData();
        if (getDeliveries) getDeliveries();

        setIsLoading(false);
        setButtonDisabled(false);
        onCloseModal();
      } else {
        toast.error(res?.data?.message || "Error while saving");
        setIsLoading(false);
        setButtonDisabled(false);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error: " + err);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  const [latestInspection, setlatestInspection] = useState<Inspection | null>(
    null
  );
  const [latestInspectionTruck, setlatestInspectionTruck] =
    useState<InspectionAsset | null>(null);
  const [latestInspectionTrailer, setlatestInspectionTrailer] =
    useState<InspectionAsset | null>(null);
  const getUserLatestInspection = async () => {
    if (userModel?.id) {
      return InspectionApi.getUserLatestInspection(userModel?.id)
        .then((res) => {
          if (res.data) {
            const latestTruck =
              res.data.inspectionAssets.find(
                (x) => x.asset?.typeId == AssetTypeEnum.Truck
              ) ?? null;
            const latestTrailer =
              res.data.inspectionAssets.find(
                (x) => x.asset?.typeId == AssetTypeEnum.Trailer
              ) ?? null;

            if (
              res.data.typeId === InspectionTypeEnum.Post &&
              res.data.mileage &&
              res.data.mileage > 0 &&
              latestTruck?.sopformId &&
              latestTruck?.sopformId > 0 &&
              latestTrailer?.sopformId &&
              latestTrailer?.sopformId > 0
            ) {
              handleResetFormValues();
            } else {
              setlatestInspection(res.data);
              setlatestInspectionTruck(latestTruck);
              setlatestInspectionTrailer(latestTrailer);
            }
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    }
  };

  function checkAccess() {
    if (userModel && userModel.userLevelId === UserLevelNames.Driver) {
      return true;
    } else {
      return false;
    }
  }

  function checkAdminAccess() {
    if (userModel && userModel.userLevelId === UserLevelNames.Admin) {
      return true;
    } else {
      return false;
    }
  }

  // Convert Date|string|null to 'YYYY-MM-DDTHH:mm' for <input type="datetime-local">
  const toLocalInputValue = (d?: Date | string | null) => {
    if (!d) return "";

    // If it's already in YYYY-MM-DDTHH:mm format, return as-is
    if (typeof d === "string" && d.includes("T") && d.length >= 16) {
      return d.slice(0, 16); // Take only YYYY-MM-DDTHH:mm part
    }

    // Parse as local time to prevent timezone conversion
    const dt = typeof d === "string" ? new Date(d) : d;
    if (isNaN(dt.getTime())) return "";

    const pad = (n: number) => String(n).padStart(2, "0");
    const yyyy = dt.getFullYear();
    const MM = pad(dt.getMonth() + 1);
    const dd = pad(dt.getDate());
    const hh = pad(dt.getHours());
    const mm = pad(dt.getMinutes());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
  };

  // Convert the input string back to local datetime format consistently
  const fromLocalInput = (v: string) => {
    if (!v) return null;

    // Return the datetime string in local format to prevent timezone conversion
    // This ensures what the user enters is what gets stored
    return v; // v is already in YYYY-MM-DDTHH:mm format from datetime-local input
  };
  const [timeErrors, setTimeErrors] = useState<string | null>(null);

  const validateTimes = (
    start?: Date | string | null,
    end?: Date | string | null
  ) => {
    const s = start ? new Date(start) : null;
    const e = end ? new Date(end) : null;
    if (s && e && e < s) return "End time must be after start time.";
    return null;
  };
  const handleChangeDateTime = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: "startTime" | "endTime" | "dateDelivered"
  ) => {
    const next = fromLocalInput(e.target.value);
    setFormData((prev) => ({
      ...prev,
      [field]: next, // Store as local datetime string instead of ISO
    }));

    // live validation only for start/end pair
    if (field === "startTime" || field === "endTime") {
      const s = field === "startTime" ? next : formData.startTime;
      const eVal = field === "endTime" ? next : formData.endTime;
      setTimeErrors(validateTimes(s, eVal));
    }
  };

  // helper to read current formData as Date
  const prevToDate = (
    getter: (f: Delivery) => Date | string | null | undefined
  ) => {
    const v = getter(formData);
    return v ? new Date(v) : null;
  };

  // Quick actions
  const setStartNow = () => {
    const now = new Date();
    const localDateTime = toLocalInputValue(now);
    setFormData((prev) => ({ ...prev, startTime: localDateTime }));
    setTimeErrors(validateTimes(localDateTime, formData.endTime));
  };

  const setEndNow = () => {
    const now = new Date();
    const localDateTime = toLocalInputValue(now);
    setFormData((prev) => ({ ...prev, endTime: localDateTime }));
    setTimeErrors(validateTimes(formData.startTime, localDateTime));
  };
  // helper (put near the top of the component file)
  const formatPhone = (raw?: string | null) => {
    if (!raw) return "";
    let d = raw.replace(/\D/g, "");
    if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
    if (d.length === 10)
      return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    return raw; // fallback if not 10 digits
  };

  return (
    <>
      <Modal
        show={show}
        className="!max-w-none"
        style={{
          maxWidth: window.innerWidth >= 1024 ? "50vw" : "100vw",
        }}
        onClose={onCloseModal}
        popup
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className="relative">
            {isLoading && <Loader />}
            <div className="w-full">
              <div className="w-full">
                <div className="mx-1 flex items-end justify-center">
                  <div className="flex flex-col md:flex-row flex-1 justify-between gap-2 md:gap-0">
                    <div className="flex flex-col md:flex-row gap-2 md:gap-3">
                      <h1 className="text-gray-900 font-bold text-xl md:text-2xl lg:text-4xl">
                        Delivery
                      </h1>
                      {checkAdminAccess() &&
                        formData.statusId === DeliveryStatusEnum.Submitted && (
                          <div className="text-sm md:text-xl">
                            <div className="w-full flex flex-col md:flex-row gap-2 md:gap-0">
                              <div className="content-center md:pl-2">
                                <Button
                                  disabled={buttonDisabled}
                                  type="button"
                                  className="buttonMainAlt w-full md:w-auto"
                                  onClick={() =>
                                    deliveryApprove(DeliveryStatusEnum.Approved)
                                  }
                                >
                                  Approve
                                </Button>
                              </div>
                              <div className="content-center md:pl-2">
                                <Button
                                  disabled={buttonDisabled}
                                  type="button"
                                  className="buttonCancel w-full md:w-auto"
                                  onClick={() =>
                                    deliveryApprove(DeliveryStatusEnum.Canceled)
                                  }
                                >
                                  Cancel
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                      {formData.statusId === DeliveryStatusEnum.Submitted && (
                        <div className="text-xl">
                          <div className="w-full flex flex-col md:flex-row gap-2 md:gap-0">
                            <div className="content-center md:pl-2">
                              <Button
                                disabled={buttonDisabled}
                                type="button"
                                className="buttonMain w-full md:w-auto"
                                onClick={() => {
                                  if (selectedDelivery) {
                                    viewDropTicket(selectedDelivery);
                                  }
                                }}
                              >
                                View Drop Ticket
                              </Button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {formData.statusId === DeliveryStatusEnum.InProcess && (
                      <Button
                        disabled={buttonDisabled}
                        type="submit"
                        className="buttonMainAlt w-full md:w-auto"
                        onClick={() => setshowSubmitDropTicket(true)}
                      >
                        Submit Drop Ticket
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="container mx-auto p-2">
                  <div className="md:flex no-wrap md:-mx-2 ">
                    <div className="w-full">
                      <div className="bg-white">
                        <hr className="bg-gray-300 h-[5px]"></hr>
                        <form id="deliveryForm" onSubmit={onSubmit}>
                          <div className="text-gray-500">
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Job Name:
                                </div>
                              </div>
                              <div className="w-full">
                                <i>
                                  {
                                    selectedDelivery?.clientLocation
                                      ?.clientSiteId
                                  }
                                </i>
                              </div>
                            </div>
                            <hr className="bg-gray-300 h-[2px]"></hr>
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Location:
                                </div>
                              </div>
                              <div className="w-full">
                                <i>
                                  {selectedDelivery?.clientLocation?.address}{" "}
                                  {selectedDelivery?.clientLocation?.city}
                                  {", "}
                                  {selectedDelivery?.clientLocation?.state
                                    ? selectedDelivery?.clientLocation?.state
                                        .name
                                    : ""}{" "}
                                  {selectedDelivery?.clientLocation?.zip}
                                </i>
                              </div>
                            </div>
                            <hr className="bg-gray-300 h-[2px]"></hr>
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Location Notes:
                                </div>
                              </div>
                              <div className="w-full">
                                <Textarea
                                  id="notes"
                                  name="notes"
                                  placeholder="Location Notes..."
                                  onChange={handleChangeTextAreaLocation}
                                  value={locationformData.notes ?? ""}
                                  rows={2}
                                  autoComplete="new-password"
                                />
                              </div>
                            </div>
                            <hr className="bg-gray-300 h-[2px]"></hr>
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Contact:
                                </div>
                              </div>
                              <div className="w-full flex flex-col md:flex-row gap-2 md:gap-0">
                                <Select
                                  id="clientContactId"
                                  name="clientContactId"
                                  onChange={handleChangeSelect}
                                  value={formData.clientContactId ?? ""}
                                  sizing="md"
                                  required
                                  className="w-full"
                                >
                                  <option value={""}>(Select)</option>
                                  {clientContacts
                                    .slice() // avoid mutating state when sorting
                                    .sort((a, b) =>
                                      `${a.firstName ?? ""} ${
                                        a.lastName ?? ""
                                      }`.localeCompare(
                                        `${b.firstName ?? ""} ${
                                          b.lastName ?? ""
                                        }`
                                      )
                                    )
                                    .map((c) => {
                                      const phone = formatPhone(
                                        (c as any).phone ??
                                          (c as any).phoneNumber ??
                                          ""
                                      );
                                      const email =
                                        (c as any).email ??
                                        (c as any).emailAddress ??
                                        (c as any).contactEmail ??
                                        "";
                                      const contactBits = [phone, email]
                                        .filter(Boolean)
                                        .join(" · ");
                                      const name = `${c.firstName ?? ""} ${
                                        c.lastName ?? ""
                                      }`.trim();
                                      return (
                                        <option key={c.id} value={c.id}>
                                          {contactBits
                                            ? `${name} — ${contactBits}`
                                            : name}
                                        </option>
                                      );
                                    })}
                                </Select>

                                <div className="content-center pl-2">
                                  <Button
                                    onClick={() => setshowAddContactModal(true)}
                                    className="buttonMain"
                                  >
                                    <HiPlus size={12} />
                                  </Button>
                                </div>
                              </div>
                            </div>
                            <hr className="bg-gray-300 h-[2px] mb-3"></hr>
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Driver:
                                </div>
                              </div>
                              <div className="w-full">
                                <Select
                                  id="deliveredBy"
                                  name="deliveredBy"
                                  onChange={handleChangeSelect}
                                  value={formData.deliveredBy?.toString() ?? ""}
                                  sizing="md"
                                  disabled={checkAccess()}
                                >
                                  <option value={""}>(Select)</option>
                                  {users
                                    .filter(
                                      (user) =>
                                        user.userLevelId ===
                                        UserLevelNames.Driver
                                    )
                                    .sort((a, b) =>
                                      (a.firstName ?? "").localeCompare(
                                        b.firstName ?? ""
                                      )
                                    )
                                    .map((user) => (
                                      <option key={user.id} value={user.id}>
                                        {user.firstName} {user.lastName}
                                      </option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                            <hr className="bg-gray-300 h-[2px] mb-3"></hr>
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Delivery Notes:
                                </div>
                              </div>
                              <div className="w-full">
                                <Textarea
                                  id="notes"
                                  name="notes"
                                  placeholder="Delivery Notes..."
                                  onChange={handleChangeTextArea}
                                  value={formData.notes ?? ""}
                                  rows={3}
                                  autoComplete="new-password"
                                />
                              </div>
                            </div>
                            <hr className="bg-gray-300 h-[2px] mb-3" />

                            {/* Start / End Times */}
                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  Start Time:
                                </div>
                              </div>
                              <div className="w-full flex flex-col md:flex-row gap-2 md:gap-2">
                                <input
                                  id="startTime"
                                  name="startTime"
                                  type="datetime-local"
                                  className="w-full border rounded p-2"
                                  value={toLocalInputValue(
                                    formData.startTime as any
                                  )}
                                  onChange={(e) =>
                                    handleChangeDateTime(e, "startTime")
                                  }
                                />
                                <Button
                                  type="button"
                                  className="buttonMainAlt"
                                  onClick={setStartNow}
                                >
                                  Now
                                </Button>
                              </div>
                            </div>

                            <hr className="bg-gray-300 h-[2px]" />

                            {timeErrors && (
                              <div className="text-red-500 text-sm mb-2 md:ml-[25%]">
                                {timeErrors}
                              </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-[25%_75%] text-sm md:text-lg lg:text-xl gap-2 md:gap-0">
                              <div className="flex">
                                <div className="font-bold content-center">
                                  End Time:
                                </div>
                              </div>
                              <div className="w-full flex flex-col md:flex-row gap-2 md:gap-2">
                                <input
                                  id="endTime"
                                  name="endTime"
                                  type="datetime-local"
                                  className="w-full border rounded p-2"
                                  value={toLocalInputValue(
                                    formData.endTime as any
                                  )}
                                  onChange={(e) =>
                                    handleChangeDateTime(e, "endTime")
                                  }
                                />
                                <Button
                                  type="button"
                                  className="buttonMainAlt"
                                  onClick={setEndNow}
                                >
                                  Now
                                </Button>
                              </div>
                            </div>
                          </div>
                        </form>
                        {selectedDelivery && (
                          <>
                            <div className="border-t-2 mt-2">
                              <div className="w-full h-[74px] p-4">
                                <div className="mx-1 flex items-end">
                                  <div className="flex flex-1">
                                    <h1 className="text-gray-900 font-bold text-xl">
                                      <div>Items</div>
                                    </h1>
                                  </div>
                                  <div className="">
                                    <Button
                                      onClick={() =>
                                        setshowDeliveryItemModal(true)
                                      }
                                      className="buttonMain"
                                    >
                                      <HiPlus size={12} />
                                    </Button>
                                  </div>
                                </div>
                              </div>
                              <DeliveryItemListTable
                                data={deliveryItems.filter(
                                  (x) => x.inventoryTypeId !== null
                                )}
                                deleteDeliveryItem={deleteDeliveryItem}
                                editDeliveryItem={editDeliveryItem}
                                deliveryStatus={
                                  // formData.statusId ??
                                  DeliveryStatusEnum.InProcess
                                }
                                editLocationAssetItem={editClientLocationAsset}
                                latestDailyPrice={latestDailyPrice}
                              />
                            </div>
                            {!checkAccess() && (
                              <div className="border-t-2 mt-2">
                                <div className="w-full h-[74px] p-4">
                                  <div className="mx-1 flex items-end">
                                    <div className="flex flex-1">
                                      <h1 className="text-gray-900 font-bold text-xl">
                                        <div>Non Inventory Items</div>
                                      </h1>
                                    </div>
                                    <div className="">
                                      <Button
                                        onClick={() =>
                                          setshowDeliveryItemNonInventoryModal(
                                            true
                                          )
                                        }
                                        className="buttonMain"
                                      >
                                        <HiPlus size={12} />
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                                <DeliveryItemNonInventoryListTable
                                  data={deliveryItems.filter(
                                    (x) => x.qbitemId !== null
                                  )}
                                  deleteDeliveryItem={deleteDeliveryItem}
                                  editDeliveryItem={editDeliveryItem}
                                  deliveryStatus={
                                    // formData.statusId ??
                                    DeliveryStatusEnum.InProcess
                                  }
                                />
                              </div>
                            )}
                            <DeliveryItemModal
                              show={showDeliveryItemModal}
                              setShow={setshowDeliveryItemModal}
                              deliveryId={selectedDelivery.id}
                              locationId={selectedDelivery.clientLocationId!}
                              getDeliveryItems={getDeliveryDeliveryItemsList}
                              getSchedulerData={getSchedulerData}
                              selectedDeliveryItem={selectedDeliveryItem}
                              setSelectedDeliveryItem={setSelectedDeliveryItem}
                            />
                            <DeliveryItemNonInventoryModal
                              show={showDeliveryItemNonInventoryModal}
                              setShow={setshowDeliveryItemNonInventoryModal}
                              deliveryId={selectedDelivery.id}
                              getDeliveryItems={getDeliveryDeliveryItemsList}
                              getSchedulerData={getSchedulerData}
                              selectedDeliveryItem={selectedDeliveryItem}
                              setSelectedDeliveryItem={setSelectedDeliveryItem}
                            />
                            <ClientLocationAssetModal
                              show={showAddNewLocationAssetModal}
                              setShow={setshowAddNewLocationAssetModal}
                              getDeliveryItems={getDeliveryDeliveryItemsList}
                              clientLocationId={
                                selectedDelivery.clientLocationId!
                              }
                              selectedClientLocationAsset={
                                selectedClientLocationAsset
                              }
                            />
                            <ClientContactModal
                              show={showAddContactModal}
                              setShow={setshowAddContactModal}
                              clientId={selectedDelivery.clientId!}
                              getContacts={getClientContacts}
                              selectedContact={null}
                            />
                            <SOPForm
                              show={showSubmitDropTicket}
                              setShow={setshowSubmitDropTicket}
                              selectedDelivery={formData}
                              deliverySubmitComplete={deliverySubmitComplete}
                              assetId={latestInspectionTrailer?.assetId ?? 0}
                            />
                          </>
                        )}
                        {!checkAccess() && (
                          <div>
                            <hr className="bg-gray-300 h-[2px] my-3"></hr>
                            <div className="flex gap-8">
                              <div className="flex-col justify-between">
                                <div className="font-bold">Totals </div>
                                <div className="flex gap-2">
                                  <div>DEF: </div>
                                  <div>
                                    {deliveryItems.reduce(
                                      (n, { defQuantity }) =>
                                        n + (defQuantity ?? 0),
                                      0
                                    )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>Dyed: </div>
                                  <div>
                                    {deliveryItems
                                      .filter(
                                        (a) =>
                                          a.inventoryTypeId ===
                                          InventoryTypeEnum.OffRoadDyedDiesel
                                      )
                                      .reduce(
                                        (n, { quantity }) =>
                                          n + (quantity ?? 0),
                                        0
                                      )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>Clear: </div>
                                  <div>
                                    {deliveryItems
                                      .filter(
                                        (a) =>
                                          a.inventoryTypeId ===
                                          InventoryTypeEnum.OnRoadClearDiesel
                                      )
                                      .reduce(
                                        (n, { quantity }) =>
                                          n + (quantity ?? 0),
                                        0
                                      )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>Other: </div>
                                  <div>
                                    {deliveryItems
                                      .filter((a) => (a.qbitemId ?? 0) > 0)
                                      .reduce(
                                        (n, { quantity }) =>
                                          n + (quantity ?? 0),
                                        0
                                      )}
                                  </div>
                                </div>
                              </div>
                              <div className="flex-col justify-between">
                                <div className="font-bold">Price </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(clientDEFPrice())}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      clientDyedDieselPrice()
                                    )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      clientClearDieselPrice()
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="flex-col justify-between">
                                <div className="font-bold">Total </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      deliveryItems.reduce(
                                        (n, { defQuantity }) =>
                                          n + (defQuantity ?? 0),
                                        0
                                      ) * clientDEFPrice()
                                    )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      deliveryItems
                                        .filter(
                                          (a) =>
                                            a.inventoryTypeId ===
                                            InventoryTypeEnum.OffRoadDyedDiesel
                                        )
                                        .reduce(
                                          (n, { quantity }) =>
                                            n + (quantity ?? 0),
                                          0
                                        ) * clientDyedDieselPrice()
                                    )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      deliveryItems
                                        .filter(
                                          (a) =>
                                            a.inventoryTypeId ===
                                            InventoryTypeEnum.OnRoadClearDiesel
                                        )
                                        .reduce(
                                          (n, { quantity }) =>
                                            n + (quantity ?? 0),
                                          0
                                        ) * clientClearDieselPrice()
                                    )}
                                  </div>
                                </div>
                                <div className="flex gap-2 border-b-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      deliveryItems
                                        .filter((a) => (a.qbitemId ?? 0) > 0)
                                        .reduce(
                                          (n, item) =>
                                            n +
                                            (item.quantity ?? 0) *
                                              (item.price ?? 0),
                                          0
                                        )
                                    )}
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <div>
                                    $
                                    {formatNumbersDisplayOnly(
                                      Math.round(
                                        (deliveryItems.reduce(
                                          (n, { defQuantity }) =>
                                            n + (defQuantity ?? 0),
                                          0
                                        ) *
                                          clientDEFPrice() +
                                          deliveryItems
                                            .filter(
                                              (a) =>
                                                a.inventoryTypeId ===
                                                InventoryTypeEnum.OffRoadDyedDiesel
                                            )
                                            .reduce(
                                              (n, { quantity }) =>
                                                n + (quantity ?? 0),
                                              0
                                            ) *
                                            clientDyedDieselPrice() +
                                          deliveryItems
                                            .filter(
                                              (a) =>
                                                a.inventoryTypeId ===
                                                InventoryTypeEnum.OnRoadClearDiesel
                                            )
                                            .reduce(
                                              (n, { quantity }) =>
                                                n + (quantity ?? 0),
                                              0
                                            ) *
                                            clientClearDieselPrice() +
                                          deliveryItems
                                            .filter(
                                              (a) => (a.qbitemId ?? 0) > 0
                                            )
                                            .reduce(
                                              (n, item) =>
                                                n +
                                                (item.quantity ?? 0) *
                                                  (item.price ?? 0),
                                              0
                                            )) *
                                          100
                                      ) / 100
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <hr className="bg-gray-300 h-[2px] my-3"></hr>
                        <div className=" text-xl">
                          <div className="flex justify-between">
                            <div className=" font-bold content-center">
                              Customer Signature:
                            </div>
                            {!formData.signature && (
                              <button
                                disabled={buttonDisabled}
                                type="button"
                                className="text-sm px-3 text-black border border-black bg-gray-100"
                                onClick={clearSignature}
                              >
                                Clear
                              </button>
                            )}
                          </div>
                          <div className="w-full bg-white border">
                            {formData.signature && (
                              <img src={formData.signature} />
                            )}
                            {!formData.signature && (
                              <SignaturePad
                                canvasProps={{
                                  className: "w-full h-full border bg-gray-100",
                                }}
                                ref={sigPadref}
                              />
                            )}
                          </div>
                        </div>
                        <div className="flex justify-end pt-2">
                          {(formData.statusId ===
                            DeliveryStatusEnum.InProcess ||
                            (formData.statusId !==
                              DeliveryStatusEnum.InProcess &&
                              !checkAccess())) && (
                            <Button
                              disabled={buttonDisabled}
                              type="submit"
                              className="buttonMain"
                              form="deliveryForm"
                            >
                              Save
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ViewReportModal
        show={showdropTicketModal}
        setShow={setshowdropTicketModal}
        url={pdfURL}
        fileName={fileName}
        blob={pdfBlob}
      />
    </>
  );
}
